/**
 * Utility Functions
 */

/**
 * Console logging (development only)
 */
export function log(message, type = "log") {
    if (import.meta.env.MODE !== "production") {
        const prefix = "[Site Package]";
        console[type](`${prefix} ${message}`);
    }
}

/**
 * Debounce function
 */
export function debounce(func, wait, immediate = false) {
    let timeout;

    return function executedFunction(...args) {
        const context = this;

        const later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

/**
 * Throttle function
 */
export function throttle(func, limit) {
    let inThrottle;

    return function executedFunction(...args) {
        const context = this;

        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => (inThrottle = false), limit);
        }
    };
}

/**
 * Check if element is in viewport
 */
export function isInViewport(element, offset = 0) {
    const rect = element.getBoundingClientRect();

    return (
        rect.top >= 0 - offset &&
        rect.left >= 0 &&
        rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) +
                offset &&
        rect.right <=
            (window.innerWidth || document.documentElement.clientWidth)
    );
}

/**
 * Generate unique ID
 */
export function uniqueId(prefix = "id") {
    return `${prefix}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * Parse JSON safely
 */
export function parseJSON(string, fallback = null) {
    try {
        return JSON.parse(string);
    } catch {
        return fallback;
    }
}
